/**
 * Padrão de desbloqueio Android (grade 3×3, pontos numerados de 1 a 9).
 *
 *   1 2 3
 *   4 5 6
 *   7 8 9
 *
 * Como no Android, ao ligar dois pontos que têm um ponto ainda não usado exatamente no meio
 * (ex.: 1 → 3 passa pelo 2), o ponto do meio entra automaticamente na sequência.
 */
export const PATTERN_MIN_POINTS = 4;

const pos = (n: number) => ({ row: Math.floor((n - 1) / 3), col: (n - 1) % 3 });

export function middlePoint(a: number, b: number): number | null {
  const pa = pos(a);
  const pb = pos(b);
  const dr = pb.row - pa.row;
  const dc = pb.col - pa.col;
  if (dr % 2 !== 0 || dc % 2 !== 0) return null;
  const mid = (pa.row + dr / 2) * 3 + (pa.col + dc / 2) + 1;
  return mid === a || mid === b ? null : mid;
}

/** Adiciona um ponto ao padrão respeitando a regra do ponto intermediário. */
export function appendPatternPoint(pattern: readonly number[], point: number): number[] {
  if (point < 1 || point > 9 || pattern.includes(point)) return [...pattern];
  const next = [...pattern];
  const last = next[next.length - 1];
  if (last !== undefined) {
    const mid = middlePoint(last, point);
    if (mid !== null && !next.includes(mid)) next.push(mid);
  }
  next.push(point);
  return next;
}

export function isValidPattern(pattern: unknown): pattern is number[] {
  if (!Array.isArray(pattern)) return false;
  if (pattern.length < PATTERN_MIN_POINTS || pattern.length > 9) return false;
  if (!pattern.every((n) => Number.isInteger(n) && n >= 1 && n <= 9)) return false;
  return new Set(pattern).size === pattern.length;
}

export const formatPattern = (pattern: readonly number[] | null | undefined) =>
  pattern && pattern.length ? pattern.join(' → ') : 'sem padrão';
